export default __webpack_public_path__ + "static/media/whatsapp.f84550ba.svg";